import api from "./api";

const route = "/addresses";

const AddressesService = {
  postAddress: (address) => api.post(route, { ...address }),
  putAddress: (address) => api.put(route, { ...address }),
};
export default AddressesService;
